import PaymentList from 'components/common/Accordion/PaymentList';
import ContainerHeader from 'components/common/ContainerHeader';
import React from 'react';
import styled from 'styled-components';
import {colors, containerStyles} from 'styles/shared';

const InvoicesContainer = styled.div`
  width: 54.4rem;
  height: 52.8rem;
  padding: 3.9rem 4.8rem 2rem 4.5rem;
  margin-bottom: 5rem;
  ${containerStyles};
`;

const InvoicesHeader = styled(ContainerHeader)`
  margin-bottom: 1rem;
`;

const comment = {
  'font-size': '2.5rem',
  'line-height': '2.2rem',
  color: `${colors.darkBlue_main}`,
  width: '100%'
};

class item {
  id = 0;
  amount = 0;
  currency = '';
  date = '';
}

function Invoices({invoices, currency}) {
  //const TEXT = 'Lorem ipsum dolor sit amet, consectetur';
  let items: item[] = [];

  for (let index = 0; index < invoices.length; index++) {
    const invoice = invoices[index];
    items.push({id: index, amount: invoice.amount, currency: currency, date: invoice.date.split('T')[0]});
  }

  function render() {
    return (
      <InvoicesContainer>
        <InvoicesHeader>Your Payments</InvoicesHeader>
        {items.length === 0 ? (
          <div style={comment}>
            Recent payments will show up here{' '}
            <span role={'img'} aria-label={'smile emoji'}>
              🙂
            </span>
          </div>
        ) : (
          <PaymentList items={items} height={40} icon="download" />
        )}
      </InvoicesContainer>
    );
  }

  return render();
}

export default Invoices;
